import {
  base_colorAlert,
  cta_linkTextPrimary,
  cta_linkTextPrimaryHover,
  grey100,
  grey400,
  text_colorTextPrimary,
  text_colorTextSecondary,
  yellow50,
  yellow200,
  yellow800,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import {
  font_2xl,
  font_family_weight_medium,
  font_family_weight_regular,
  font_lg,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export const containerCss = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(10)};
  padding: ${spacing(10)};
`

export const headingSectionCss = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};
`

export const headingBlockCss = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
`

export const headerRowCss = css`
  display: flex;
  align-items: center;
  gap: ${spacing(1)};
`

export const headerTitleCss = css`
  ${font_2xl};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
`

export const headerLogoCss = css`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`

export const supportLineCss = css`
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextSecondary};
  margin: 0;
`

export const supportLinkCss = css`
  color: ${cta_linkTextPrimary};
  text-decoration: underline;
  font-family: ${font_family_weight_medium};

  &:hover {
    color: ${cta_linkTextPrimaryHover};
  }
`

export const fieldGroupCss = css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};
`

export const fieldLabelCss = css`
  ${font_lg};
  font-family: ${font_family_weight_medium};
  color: ${text_colorTextPrimary};
`

export const confirmHighlightCss = css`
  color: ${base_colorAlert};
  font-family: ${font_family_weight_medium};
`

export const inputContainerCss = css`
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  padding: ${spacing(4)} ${spacing(5)};
  border-radius: ${cornerRadius};
  background-color: ${grey100};
  border: 1px solid ${grey400};
  overflow: hidden;
`

export const inputCss = css`
  flex: 1;
  width: 100%;
  height: 18px;
  background-color: transparent;
  border: none;
  outline: none;
  padding: 0;
  ${font_md};
  font-family: ${font_family_weight_regular};
  color: ${text_colorTextPrimary};
  text-transform: uppercase;

  &::placeholder {
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    text-transform: none;
  }
`

export const footerCss = css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
`

export const warningPanelCss = css`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${spacing(3)};
  padding: ${spacing(4)} ${spacing(5)};
  border-radius: ${cornerRadius};
  background-color: ${yellow50};
  border: 1px solid ${yellow200};
  color: ${yellow800};
`

export const warningIconWrapperCss = css`
  display: flex;
  flex-shrink: 0;
`

export const warningBodyCss = css`
  ${font_sm};
  color: ${yellow800};
  font-family: ${font_family_weight_regular};
  margin: 0;
`

export const warningEmphasisCss = css`
  font-family: ${font_family_weight_medium};
`

export const cancelButtonCss = css`
  ${font_md};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${text_colorTextSecondary};
  font-family: ${font_family_weight_medium};

  &:hover {
    color: ${text_colorTextPrimary};
  }
`
